import React from "react";
import { useTranslation } from "react-i18next";
import { Languages } from "lucide-react";
import LanguageSwitcher from "../../i18n/LanguageSwitcher";

export default function LanguageSection() {
  const { t } = useTranslation("common");
  const T = (k, o) => t(`settings.profile.${k}`, o);

  return (
    <section className="border border-zinc-200 rounded-2xl bg-white p-6 mb-6" data-testid="profile-language-section">
      <div className="flex items-center gap-3 mb-4">
        <span className="inline-flex items-center justify-center w-10 h-10 rounded-lg bg-zinc-100 text-zinc-700">
          <Languages size={18} strokeWidth={1.75} />
        </span>
        <div>
          <h2 className="font-display text-lg font-semibold text-zinc-950">{T("language.title")}</h2>
          <p className="text-xs text-zinc-500 mt-0.5 max-w-md">{T("language.subtitle")}</p>
        </div>
      </div>

      <p className="text-xs text-zinc-500 mb-1">{T("language.label")}</p>
      <LanguageSwitcher variant="compact" testIdPrefix="profile-lang" />
    </section>
  );
}
